var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#650D1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 29.9997L42.2071 29.2926L42.9142 29.9997L42.2071 30.7068L41.5 29.9997ZM18.5 30.9997C17.9477 30.9997 17.5 30.552 17.5 29.9997C17.5 29.4474 17.9477 28.9997 18.5 28.9997V30.9997ZM34.5404 21.6259L42.2071 29.2926L40.7929 30.7068L33.1262 23.0401L34.5404 21.6259ZM42.2071 30.7068L34.5404 38.3734L33.1262 36.9592L40.7929 29.2926L42.2071 30.7068ZM41.5 30.9997H18.5V28.9997H41.5V30.9997Z",
    fill: "#FFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogArrow);
export default __webpack_public_path__ + "static/media/blogArrow.bcae21f3216d7cef0ae9e64dfcb62374.svg";
export { ForwardRef as ReactComponent };